import { render } from "./DriverMenu.vue?vue&type=template&id=15cef12a&ts=true"
import script from "./DriverMenu.vue?vue&type=script&lang=ts"
export * from "./DriverMenu.vue?vue&type=script&lang=ts"
/* custom blocks */
import block0 from "./DriverMenu.vue?vue&type=custom&index=0&blockType=i18n&locale=en"
if (typeof block0 === 'function') block0(script)
import block1 from "./DriverMenu.vue?vue&type=custom&index=1&blockType=i18n&locale=fr"
if (typeof block1 === 'function') block1(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__